
<ng-container *ngIf="permissions.canRead(permissions.ComponentID.ViewInventory)">
<div class="container-fluid" >
  <div class="row top10">
    <div class="col-xs-12 col-lg-4 vcenter">
      <h3>View Inventory</h3>
    </div>
    <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">
            Work Order #: <input [(ngModel)]="workOrderNumber" name="workOrderNumber" (enter)="openTicketPrint()" />&nbsp;
             <!-- <aims-common-button
                (click)="sendLatestAlert()" >
                <mat-icon color="primary">email</mat-icon>
                Send Latest Alerts
            </aims-common-button>
             <aims-common-button
                (click)="sendDailyAlerts()" >
                <mat-icon color="primary">email</mat-icon>
                Send Daily Alerts
            </aims-common-button> -->
            <aims-common-button
                title="Ticket"
                aria-label="Ticket"
                (click)="openTicketPrint()" >
                <mat-icon color="primary">list</mat-icon>
                Inventory Ticket
            </aims-common-button>
            <aims-common-button
                title="Cart"
                aria-label="Cart"
                (click)="showShoppingCart()" >
                <mat-icon color="primary">shopping_cart</mat-icon>
                {{ totalCartItems() }}
            </aims-common-button>
         <aims-grid-selector gridKey="inventoryGrid" (gridSelected)="gridChange($event)"></aims-grid-selector>
        </div>
    </div>
  </div>
  
  <div class="row top10">
    <div class="col-xs-12 col-lg-12 left">
      <ng-container>
        <mat-label>Include Inactive Inventories?:&nbsp;&nbsp;</mat-label>
        <mat-checkbox style="width: 15px" id="Include Inactive Inventories" name="Include Inactive Inventories"
          (click)="inventoryListChecked()"></mat-checkbox>
      </ng-container>
    </div>
  </div>

  <hr style="margin-top: 2px; margin-bottom: 2px" />

  <div class="row top10">
  <aims-common-table
    id="inventory-table"
    [dataSource]="inventoryList | async"
    [defaultTableState] = "defaultTableState"
    [header]="grid === 'full' ? headerFull : header"
    [permissions]="invTablePermissions"
    [exportFunction]="getForExcel"
    (selectionClick)="handleSelections($event)"
    (selectionAllClick)="handleAllSelections($event)"
    (onPrint)="handlePrint($event)"
    (rowExpanded)="handleRowExpand($event)"
    (everyAlert)="gridAlert.everyAlert($event)"
    (dailyAlert)="gridAlert.dailyAlert($event)"
    hasGridAlert="true"
    [everyChangeAlertSelected]="gridAlert.isAllChangesSubscribed"
    [dailyChangeAlertSelected]="gridAlert.isDailyChangesSubscribed"
    pageSize="10"
    [stickyHeader]="true">

    <ng-template aimsCommonTableDynamicToolbar>
      <aims-common-button [matMenuTriggerFor]="matmenu"
              attr.aria-label="Print QR Label" title="Print QR Label">
           <mat-icon>qr_code</mat-icon>
           <span *ngIf="selectedItems.length == 0">Print Labels</span>
           <span *ngIf="selectedItems.length != 0">Print Selected Labels</span>
      </aims-common-button>
      <mat-menu #matmenu="matMenu">
            <button mat-menu-item (click)="handlePrint('2x4')"> <span>2x4</span> </button>
            <button mat-menu-item (click)="handlePrint('1x2')"> <span>1x2</span> </button>
            <button mat-menu-item (click)="handlePrint('075x2')"> <span>0.75x2</span> </button>
            <button mat-menu-item (click)="handlePrint('05x15')"> <span>0.5x1.5</span> </button>
            <button mat-menu-item (click)="handlePrint('0375x2')"> <span>0.375x2</span> </button>
            <button mat-menu-item (click)="handlePrint('1x25sheet')"> <span>1x2.5 Sheet</span> </button>
      </mat-menu>
    </ng-template>

    <aims-common-table-dynamic-row id="siteId">
      <ng-template aimsHeaderTemplate let-formGroup="formGroup">
        <div
          matTooltipClass="matToolTipMultiLine"
          matTooltipPosition="above"
          matTooltip="Site Id of Inventory Item">Site ID <i class="fas fa-question-circle"></i>
        </div>
      </ng-template>

      <ng-template viewMode let-element>{{ element.siteId | getText:'siteId':'siteCode':sites }}</ng-template>
      <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
        <mat-form-field appearance="fill" class="form-component">
          <mat-label>Site</mat-label>
          <mat-select [formControl]="dynamicControl">
            <mat-option></mat-option>
            <mat-option *ngFor="let val of sites" [value]="val.siteId">
              {{val.siteCode}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="dynamicControl.hasError('required')">You must make a selection</mat-error>
        </mat-form-field>
      </ng-template>
      <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
        <mat-form-field appearance="fill" style="margin-top: 20px; width: 100%">
          <mat-label>Filter</mat-label>
          <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
            <mat-option label=""></mat-option>
            <mat-option *ngFor="let val of sites" [value]="val.siteId">
              {{val.siteCode}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="workSectionId">
      <ng-template aimsHeaderTemplate let-formGroup="formGroup">
        <div
          matTooltipClass="matToolTipMultiLine"
          matTooltipPosition="above"
          matTooltip="Work Section Id of Inventory Item">Work Section <i class="fas fa-question-circle"></i>
        </div>
      </ng-template>
      <ng-template viewMode let-element>{{ element.workSectionId | getText:'workSectionId':'workSection':workSections | async }}</ng-template>
      <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
        <mat-form-field appearance="fill" style="margin-top: 20px; width: 100%">
          <mat-label>Filter</mat-label>
          <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
            <mat-option label=""></mat-option>
            <mat-option *ngFor="let ws of workSections | async" [value]="ws.workSectionId">
              {{ ws.workSection }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="quantity">
      <ng-template viewMode let-element >
         {{ getInventoryQuantity(element.inventoryItemId, invRec | async) }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="daysRemaining">
      <ng-template viewMode let-element >
         {{ getDaysInvRemaining(element.inventoryItemId, invRec | async, invExp | async) }}
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="ownerId">
      <ng-template viewMode let-element >
         {{ element.ownerId| getText:'equipmentOwnerId':'equipmentOwner':owners| async }}
      </ng-template>

      <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
        <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
          <mat-label>Filter</mat-label>
          <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
            <mat-option label=""></mat-option>
            <mat-option *ngFor="let o of owners | async" [value]="o.equipmentOwnerId">
              {{ o.equipmentOwner }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="locationId">
      <ng-template viewMode let-element >
        {{ element.locationId | getText:'locationId':'location':locations | async }}
      </ng-template>

      <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
        <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
          <mat-label>Filter</mat-label>
          <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
            <mat-option label=""></mat-option>
            <mat-option *ngFor="let l of locations | async" [value]="l.locationId">
              {{ l.location }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>
    </aims-common-table-dynamic-row>

    <aims-common-table-dynamic-row id="subLocationId">
      <ng-template viewMode let-element >
        {{ element.subLocationId | getText:'subLocationId':'subLocation':subLocations | async }}
      </ng-template>

      <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
        <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
          <mat-label>Filter</mat-label>
          <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
            <mat-option label=""></mat-option>
            <mat-option *ngFor="let sl of subLocations | async" [value]="sl.subLocationId">
              {{ sl.subLocation }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ng-template>
    </aims-common-table-dynamic-row>

    <!-- sub-tables -->
    <ng-template aimsCommonTableExpandedRow let-element>
      <aims-common-table *ngIf="permissions.canRead(permissions.ComponentID.InventoryReceipt)"
        label="Inventory Received"
        [id]="'received-table-' + element.position"
        class="sub-table"
        [dataSource]="inventoryRec | async"
        [header]="elementReceivedHeader"
        [permissions]="{ filter: false,
            create: false,
            update: permissions.canUpdate(permissions.ComponentID.InventoryReceipt),
            delete: false }"
        [pageSize]="5"
        (rowUpdated)="handleReceiveRowUpdate($event)"
        [hidePageSize]="true"
      >
        <aims-common-table-dynamic-row id="costPerUnit">
          <ng-template viewMode let-element >
             {{ element.costPerUnit | currency }}
          </ng-template>
          <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">

            <mat-form-field appearance="fill" class="editable-text-field">
                <input matInput placeholder="" autocomplete="off" [formControl]="dynamicControl"
                    mask="separator.2" thousandSeparator=","  separatorLimit="10000000" [allowNegativeNumbers]="false" />
            </mat-form-field>
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>

      <aims-common-table *ngIf="permissions.canRead(permissions.ComponentID.InventoryAdjust)"
        label="Adjustments"
        [id]="'adjustments-table-' + element.position"
        class="sub-table"
        [dataSource]="inventoryAdj | async"
        [header]="elementAdjustmentsHeader"
        [permissions]="{ filter: false, create: false, update: false, 'delete': false }"
        [pageSize]="5"
        [hidePageSize]="true"
      >
        <aims-common-table-dynamic-row id="adjustedByUserId">
          <ng-template viewMode let-element >
             {{ element.adjustedByUserId| getText:'employeeId':'fullName':employeeValues }}
          </ng-template>
        </aims-common-table-dynamic-row>
      </aims-common-table>

      <aims-common-table *ngIf="permissions.canRead(permissions.ComponentID.InventoryExpend)"
        label="Expended"
        [id]="'expended-table-' + element.position"
        class="sub-table"
        [dataSource]="inventoryExp | async"
        [header]="elementExpendedHeader"
        [permissions]="{ filter: false, create: false, update: false, delete: false }"
        [pageSize]="5"
        [hidePageSize]="true"
      >
        <aims-common-table-dynamic-row id="pulledByEmployeeId">
          <ng-template viewMode let-element >
             {{ element.pulledByEmployeeId| getText:'employeeId':'fullName':employeeValues }}
          </ng-template>
        </aims-common-table-dynamic-row>

        <aims-common-table-dynamic-row id="attachedToType">
          <ng-template viewMode let-element >
            {{ element.attachedToType | getText:'inventoryAttachedToTypeId':'attachedToType':attachedToTypes | async }}
          </ng-template>
        </aims-common-table-dynamic-row>

      </aims-common-table>
    </ng-template>
  </aims-common-table>

  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>

</ng-container>
